import React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames'

const SkipTo = React.memo(({ text, hash, clickHandler, extraClass }) => {
  const { t } = useTranslation();

  return (
  <a href={hash} className={cn("skip-to", extraClass)} onClick={clickHandler}>
    {t('skip_to.default_text')}: {text}
  </a>
  )
});

export default SkipTo;
